var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"align":"center"}},[_vm._m(0),_c('ul',{staticClass:"icons"},_vm._l((this.skills),function(item,key){return _c('li',{key:key,staticClass:"skills"},[_c('i',{class:item})])}),0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"titles mt-3"},[_c('h5',[_vm._v("Languages and Frameworks")])])
}]

export { render, staticRenderFns }